import { upperFirst } from "lodash";

export function reasonCodeLabel(code: string): string {
  return upperFirst(code.toLowerCase().replaceAll("_", " "));
}

export function toTimestamp(date: Date): number {
  return date.getTime();
}

// Display order for SKUs across the pricing UI.
export const SKU_NAME_DISPLAY_ORDER = [
  "10DLC SMS",
  "10DLC MMS",
  "Toll-Free SMS",
  "Toll-Free MMS",
  "Short Code SMS",
  "Short Code MMS",
];

export function compareSkuNames(a: string, b: string): number {
  const ia = SKU_NAME_DISPLAY_ORDER.indexOf(a);
  const ib = SKU_NAME_DISPLAY_ORDER.indexOf(b);
  if (ia !== -1 && ib !== -1) {
    return ia - ib;
  }
  if (ia !== -1) {
    return -1;
  }
  if (ib !== -1) {
    return 1;
  }
  return a.localeCompare(b);
}
